import React from 'react';
import type { SaleBannerProps as SaleBannerUIProps } from '@wix/app-market-components';
import { SaleBanner as SaleBannerUI } from '@wix/app-market-components';
import { appMarketSaleBannerImpressionWebMobile } from '@wix/bi-logger-app-market-data/v2';
import {
  useEssentials,
  useRouterContext,
  getPathForBi,
  useSiteContext,
} from '@wix/app-market-core';
import { RoutePath } from '@wix/app-market-core-types';

export interface SaleBannerProps {
  layout: SaleBannerUIProps['layout'];
}

export function SaleBanner({ layout }: SaleBannerProps) {
  const { biLogger } = useEssentials();
  const { route, router } = useRouterContext();
  const { languageCode } = useSiteContext();

  React.useEffect(() => {
    biLogger.report(
      appMarketSaleBannerImpressionWebMobile({
        tag_type: getPathForBi(route.path),
        sale_name: 'nov-25',
        action_type: 'impression',
      }),
    );
  }, []);

  const handleClick = () => {
    biLogger.report(
      appMarketSaleBannerImpressionWebMobile({
        tag_type: getPathForBi(route.path),
        sale_name: 'nov-25',
        action_type: 'click',
      }),
    );
    router.navigateTo({
      path: RoutePath.COLLECTION,
      payload: { slug: 'holiday-sale' },
    });
  };

  return (
    <SaleBannerUI
      languageCode={languageCode}
      layout={layout}
      onClick={handleClick}
    />
  );
}
